import {
  Component,
  forwardRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { LaboratoryService } from "../../../service/laboratory/laboratory.service";

export const LABORATORY_AUTOCOMPLETE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteLaboratoryComponent),
  multi: true,
};

@Component({
  selector: "app-autocomplete-laboratory",
  templateUrl: "./autocomplete-laboratory.component.html",
  styleUrls: ["./autocomplete-laboratory.component.scss"],
  providers: [LABORATORY_AUTOCOMPLETE_VALUE_ACCESSOR],
})
export class AutocompleteLaboratoryComponent implements ControlValueAccessor {
  @Input() laboratoryId: number;
  @Input() disabled: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() placeholder: string = "Buscar laboratorio";
  @Output() onMyChange = new EventEmitter<any>();

  @ViewChild("input") autoComplete;

  public options: any[] = [];
  public selectedLab: any;

  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor(private laboratoryService: LaboratoryService) {}

  ngOnInit() {
    this.loadInitialLaboratory();
  }

  private loadInitialLaboratory() {
    this.laboratoryService
      .getLaboratory(1, 10, null, null, [
        { key: "id", value: String(this.laboratoryId) },
      ])
      .toPromise()
      .then((response) => {
        const labs = response.json().data;
        if (labs && labs.length > 0) {
          this.selectedLab = labs[0];
          this.options = labs;
          this.emitOutput(this.selectedLab);
        }
      })
      .catch((error) => {
        console.error("Error loading initial laboratory:", error);
      });
  }

  loadLaboratoriesLazy(event) {
    const query = event.query.replace(/\s/g, "%");
    this.laboratoryService
      .getLaboratory(1, 10, null, query)
      .toPromise()
      .then((response) => {
        this.options = response.json().data || [];
      })
      .catch((error) => {
        console.error("Error loading laboratories:", error);
        this.options = [];
      });
  }

  onLabSelect(event) {
    this.selectedLab = event;
    this.emitOutput(event);
  }

  private emitOutput(value: any) {
    if (value && (value.id || value === "")) {
      this.onChange(value);
      this.onTouched(value);
      this.onMyChange.emit(value);
    }
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    if (value && value.id) {
      this.selectedLab = value;
      if (!this.laboratoryId) {
        this.laboratoryId = value.id;
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/medical-exams/autocomplete-laboratories/autocomplete-laboratory.component.ts